import {
  SET_STATION,
  SENDING_CAMERAS_REQUEST,
  FETCH_CAMERAS_SUCCESS,
  FETCH_CAMERAS_FAILURE,
  SENDING_CAMERA_CREATE,
  CREATE_CAMERA_FAILURE,
  SENDING_CAMERA_UPDATE,
  UPDATE_CAMERA_FAILURE,
  SENDING_CAMERA_DELETE,
  DELETE_CAMERA_FAILURE,
  FETCH_CAMERA_CATEGORIES_SUCCESS,
  FETCH_CAMERA_CATEGORIES_FAILURE,
  SENDING_CAMERAS_BY_PERMISSION_REQUEST,
  FETCH_CAMERAS_BY_PERMISSION_REQUEST,
  FETCH_CAMERAS_BY_PERMISSION_SUCCESS,
  FETCH_CAMERAS_BY_PERMISSION_FAILURE
} from '../actions/constants'

const initialState = {
  cameras: [],
  camerasByPermission: [],
  categories: [],
  fetching: false,
  sessionPulling: Math.random().toString(36).substr(2, 10),
  error: ''
}

const camera = (state = initialState, action) => {
  switch (action.type) {
    case SENDING_CAMERAS_REQUEST:
    case SENDING_CAMERA_CREATE:
    case SENDING_CAMERA_UPDATE:
    case SENDING_CAMERA_DELETE:
    case SENDING_CAMERAS_BY_PERMISSION_REQUEST:
      return {
        ...state,
        fetching: action.sending
      }
    case SET_STATION:
      return {
        ...state,
        cameras: []
      }
    case FETCH_CAMERAS_SUCCESS:
      return {
        ...state,
        cameras: action.cameras
      }
    case FETCH_CAMERAS_BY_PERMISSION_SUCCESS:
      return {
        ...state,
        camerasByPermission: action.camerasByPermission
      }
    case FETCH_CAMERAS_BY_PERMISSION_FAILURE:
    case FETCH_CAMERAS_FAILURE:
      return {
        ...state,
        error: action.error
      }
    case CREATE_CAMERA_FAILURE:
      return {
        ...state,
        error: action.error
      }
    case UPDATE_CAMERA_FAILURE:
      return {
        ...state,
        error: action.error
      }
    case DELETE_CAMERA_FAILURE:
      return {
        ...state,
        error: action.error
      }
    case FETCH_CAMERA_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.categories
      }
    case FETCH_CAMERA_CATEGORIES_FAILURE:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default camera



// WEBPACK FOOTER //
// ./src/reducers/camera.js